//
// Copyright 2024 DXOS.org
//

// TODO(dmaretskyi): Rename all symbols that are props to end with *Key.
export const EventId = Symbol.for('@dxos/live-object/EventId');
export const ChangeId = Symbol.for('@dxos/live-object/ChangeId');
